interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center flex-wrap gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="inline-flex items-center gap-1 h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`w-9 h-9 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
            page === current
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-500'
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="inline-flex items-center gap-1 h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}